import React, { Component } from 'react'
import Waveform from '../Waveform'
import FavoriteButton from '../products/FavoriteButton'
import Cover from '../products/Cover';
import ItemCheckbox from '../products/ItemCheckbox'
import DownloadItem from '../products/DownloadItem'
import { inject, observer } from 'mobx-react'
import PointItemActive from '#images/point-item-active.svg'
import Point from '#images/point.svg'

@inject('playlistStore')
@observer
class PlaylistItem extends Component {
  removeFromPlaylist = () => {
    this.props.playlistStore.remove([this.props.item.id]);
  }

  play = (e) => {
    e.stopPropagation()
    const { playlistStore, item } = this.props
    if (item.hasAudio) {
      playlistStore.play(item)
      playlistStore.traversingMode = 'playlist'
    }
  }

  get active() {
    return this.props.playlistStore.traversingMode == 'playlist' &&
      this.props.playlistStore.currentlyPlays &&
      this.props.playlistStore.currentlyPlays.id == this.props.item.id
  }

  get waveformPendingColor() {
    return this.active ? '#272B2D' : null
  }

  render() {
    return (
      <div
        onClick={this.play}
        className={`flex items-center border-b border-b-gray-7 cursor-pointer pl-[5%] ${this.active ? 'bg-beige-1' : 'bg-gray-15 hover:bg-[#3E3E3E]'}`}
      >
        <div className='flex md:w-[4%] lg:w-[2.7%]'>
          <ItemCheckbox alwaysChecked={true} onChange={this.removeFromPlaylist} />
        </div>

        <div className='flex'>
          <Cover cover={this.props.item.cover} />
        </div>

        <div className='flex md:w-[27%] lg:w-[19%] px-3'>
          <Waveform
            encodedData={this.props.item.encodedData}
            pendingColor={this.waveformPendingColor}
            height='38'
          />
        </div>

        <div className='flex md:w-[33%] lg:w-[31%]'>
          <span className={`font-bold text-sm line-clamp-2 break-all ${this.active ? 'text-gray-16' : ''}`}>
            {this.props.item.name}
          </span>
        </div>

        <div className='flex md:w-[14%] lg:w-[10%]'>
          <FavoriteButton item={this.props.item} invertedColors={this.active} />
        </div>

        {
          this.props.item.owned &&
            <div className='flex justify-center md:w-[14%] lg:w-[10%]'>
              <DownloadItem
                item={this.props.item}
                yellowLabel={this.props.item.yellowLabel}
              />
            </div>
        }

        {
          !this.props.item.owned &&
            <div className='flex justify-center md:w-[14%] lg:w-[10%]'>
              <span className={`text-xs font-bold leading-[19px] ${this.active ? 'text-gray-16' : ''}`}>{this.props.item.points}</span>
              <img
                className='w-[19px] h-[19px] ml-0.5'
                src={this.active ? PointItemActive : Point}
              />
            </div>
        }
      </div>
    )
  }
}

export default PlaylistItem
